document.addEventListener('DOMContentLoaded', () => {
  // Comportamento Accordion: Chiude le altre tab quando se ne apre una
  const accordions = document.querySelectorAll('.js-accordion-group .js-details');

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector('.mp-summary');
    
    summary.addEventListener('click', (e) => {
      // Se stiamo per aprire questo accordion
      if (!accordion.hasAttribute('open')) {
        // Chiudi tutti gli altri
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== accordion && otherAccordion.hasAttribute('open')) {
            otherAccordion.removeAttribute('open');
          }
        });
      }
    });
  });
});